const METHODS = [
  { src: "/pay/visa.png", label: "Visa" },
  { src: "/pay/mastercard.png", label: "Mastercard" },
  { src: "/pay/amex.png", label: "American Express" },
  { src: "/pay/cartes-bancaires.png", label: "Cartes Bancaires" },
  { src: "/pay/apple-pay.png", label: "Apple Pay" },
  { src: "/pay/google-pay.png", label: "Google Pay" },
  { src: "/pay/ideal.png", label: "iDEAL" },
  { src: "/pay/bancontact.png", label: "Bancontact" },
  { src: "/pay/sepa.png", label: "SEPA bank transfer" },
  { src: "/pay/stripe.png", label: "Stripe" },
];

/** Accepted payment methods — bare logos, no chips. On dark backgrounds the
 *  row sits on one light band so the dark brand marks stay legible. */
export const PaymentMethods = ({ tone = "light", note = true, className = "" }) => {
  const dark = tone === "dark";
  return (
    <div className={className} data-testid="payment-methods">
      <div
        style={{
          display: "flex", flexWrap: "wrap", gap: 18, alignItems: "center",
        }}
      >
        {METHODS.map((m) => (
          <img
            key={m.label}
            src={m.src}
            alt={m.label}
            title={m.label}
            loading="lazy"
            data-testid={`pay-${m.label.split(" ")[0].toLowerCase()}`}
            style={{ height: 26, width: "auto", objectFit: "contain", display: "block" }}
          />
        ))}
      </div>
      {note && (
        <p
          style={{
            marginTop: 10, fontSize: 11.5, letterSpacing: ".01em",
            color: dark ? "rgba(255,255,255,.6)" : "var(--cd-gray-500)",
          }}
        >
          Cards, iDEAL, Bancontact, Apple Pay, Google Pay, Cartes Bancaires and SEPA secured by Stripe · 3-D Secure · no card details touch our servers.
        </p>
      )}
    </div>
  );
};

export default PaymentMethods;
